"use strict";
const translations = {
    pt: {
        'nav-home': 'Início',
        'nav-services': 'Serviços',
        'nav-contact': 'Contato',
        'hero-title': 'Soluções Inovadoras em Tecnologia',
        'hero-subtitle': 'Transformando ideias em resultados',
        'contact-btn': 'Fale Conosco',
        'all-rights': 'Todos os direitos reservados',
        'services-title': 'Nossos Serviços',
        'services-subtitle': 'Oferecemos soluções completas em tecnologia',
        'service-web-title': 'Desenvolvimento Web',
        'service-web-desc': 'Websites modernos e aplicações web responsivas com as melhores práticas do mercado.',
        'service-mobile-title': 'Aplicativos Mobile',
        'service-mobile-desc': 'Aplicativos nativos e híbridos para iOS e Android com excelente performance.',
        'service-consult-title': 'Consultoria Técnica',
        'service-consult-desc': 'Consultoria especializada para otimizar sua infraestrutura e processos tecnológicos.',
        'service-data-title': 'Análise de Dados',
        'service-data-desc': 'Extração e análise de dados para tomadas de decisão mais inteligentes.',
        'service-security-title': 'Segurança da Informação',
        'service-security-desc': 'Proteção completa dos seus dados e sistemas contra ameaças digitais.',
        'service-cloud-title': 'Soluções em Nuvem',
        'service-cloud-desc': 'Migração e implementação de soluções cloud escaláveis e seguras.',
        'contact-title': 'Entre em Contato',
        'contact-subtitle': 'Vamos conversar sobre seu projeto',
        'contact-info-title': 'Informações de Contato',
        'contact-address-label': 'Endereço:',
        'contact-address': '21 Harle Avenue, Wilston',
        'contact-phone-label': 'Telefone:',
        'contact-email-label': 'Email:',
        'contact-map-link': 'Ver no Google Maps',
        'form-name': 'Seu Nome',
        'form-email': 'Seu Email',
        'form-phone': 'Seu Telefone',
        'form-message': 'Sua Mensagem',
        'form-submit': 'Enviar Mensagem'
    },
    it: {
        'nav-home': 'Home',
        'nav-services': 'Servizi',
        'nav-contact': 'Contatto',
        'hero-title': 'Soluzioni Tecnologiche Innovative',
        'hero-subtitle': 'Trasformare idee in risultati',
        'contact-btn': 'Contattaci',
        'all-rights': 'Tutti i diritti riservati',
        'services-title': 'I Nostri Servizi',
        'services-subtitle': 'Offriamo soluzioni tecnologiche complete',
        'service-web-title': 'Sviluppo Web',
        'service-web-desc': 'Siti web moderni e applicazioni web responsive con le migliori pratiche del settore.',
        'service-mobile-title': 'Applicazioni Mobile',
        'service-mobile-desc': 'Applicazioni native e ibride per iOS e Android con prestazioni eccellenti.',
        'service-consult-title': 'Consulenza Tecnica',
        'service-consult-desc': 'Consulenza specializzata per ottimizzare la tua infrastruttura e i processi tecnologici.',
        'service-data-title': 'Analisi dei Dati',
        'service-data-desc': 'Estrazione e analisi dei dati per decisioni più intelligenti.',
        'service-security-title': 'Sicurezza Informatica',
        'service-security-desc': 'Protezione completa dei tuoi dati e sistemi contro le minacce digitali.',
        'service-cloud-title': 'Soluzioni Cloud',
        'service-cloud-desc': 'Migrazione e implementazione di soluzioni cloud scalabili e sicure.',
        'contact-title': 'Mettiti in Contatto',
        'contact-subtitle': 'Parliamo del tuo progetto',
        'contact-info-title': 'Informazioni di Contatto',
        'contact-address-label': 'Indirizzo:',
        'contact-address': '21 Harle Avenue, Wilston',
        'contact-phone-label': 'Telefono:',
        'contact-email-label': 'Email:',
        'contact-map-link': 'Visualizza su Google Maps',
        'form-name': 'Il Tuo Nome',
        'form-email': 'La Tua Email',
        'form-phone': 'Il Tuo Telefono',
        'form-message': 'Il Tuo Messaggio',
        'form-submit': 'Invia Messaggio'
    },
    en: {
        'nav-home': 'Home',
        'nav-services': 'Services',
        'nav-contact': 'Contact',
        'hero-title': 'Innovative Technology Solutions',
        'hero-subtitle': 'Transforming ideas into results',
        'contact-btn': 'Contact Us',
        'all-rights': 'All rights reserved',
        'services-title': 'Our Services',
        'services-subtitle': 'We offer complete technology solutions',
        'service-web-title': 'Web Development',
        'service-web-desc': 'Modern websites and responsive web applications with industry best practices.',
        'service-mobile-title': 'Mobile Applications',
        'service-mobile-desc': 'Native and hybrid applications for iOS and Android with excellent performance.',
        'service-consult-title': 'Technical Consulting',
        'service-consult-desc': 'Specialized consulting to optimize your infrastructure and technological processes.',
        'service-data-title': 'Data Analysis',
        'service-data-desc': 'Data extraction and analysis for smarter decision making.',
        'service-security-title': 'Information Security',
        'service-security-desc': 'Complete protection of your data and systems against digital threats.',
        'service-cloud-title': 'Cloud Solutions',
        'service-cloud-desc': 'Migration and implementation of scalable and secure cloud solutions.',
        'contact-title': 'Get in Touch',
        'contact-subtitle': "Let's talk about your project",
        'contact-info-title': 'Contact Information',
        'contact-address-label': 'Address:',
        'contact-address': '21 Harle Avenue, Wilston',
        'contact-phone-label': 'Telephone:',
        'contact-email-label': 'Email:',
        'contact-map-link': 'View on Google Maps',
        'form-name': 'Your Name',
        'form-email': 'Your Email',
        'form-phone': 'Your Phone',
        'form-message': 'Your Message',
        'form-submit': 'Send Message'
    }
};
let currentLanguage = localStorage.getItem('language') || 'en';
function translatePage(lang) {
    currentLanguage = lang;
    localStorage.setItem('language', lang);
    document.querySelectorAll('[data-i18n]').forEach((element) => {
        const key = element.getAttribute('data-i18n') || '';
        const text = translations[lang][key];
        if (!text)
            return;
        if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) {
            element.placeholder = text;
        }
        else {
            element.textContent = text;
        }
    });
    document.querySelectorAll('.lang-btn').forEach((btn) => {
        btn.classList.remove('active');
        if (btn.getAttribute('data-lang') === lang)
            btn.classList.add('active');
    });
}
document.addEventListener('DOMContentLoaded', () => {
    translatePage(currentLanguage);
    document.querySelectorAll('.lang-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
            const lang = btn.getAttribute('data-lang') || 'en';
            translatePage(lang);
        });
    });
});
